'use strict';

class EditPayment {
  constructor($filter, $routeParams, $location, commonService, invoiceService, salesLedgerService, I18N, Notification) {
    this.$filter = $filter;
    this.$location = $location;
    this.commonService = commonService;
    this.invoiceService = invoiceService;
    this.salesLedgerService = salesLedgerService;
    this.I18N = I18N;
    this.Notification = Notification;

    this.invoiceNumber = $routeParams.number;
    this.paymentNumber = $routeParams.paymentNumber;
  }

  $onInit() {
    this.entries = [];
    this.balance = 0;
    this.payment = {};
    this.data = {};
    this.invoice = {};
    this.action = 'edit';

    this.commonService.datePicker({
      field: $('#date')[0]
    });

    this.load();
    this.loadSalesLedger();
  }

  load() {
    this.salesLedgerService.get(this.paymentNumber)
      .then((resp) => {
        this.data = resp.data;
        return resp.data;
      })
      .then((data) => {
        this.payment = {
          date: moment(data.date, 'YYYY-MM-DD').format('DD.MM.YY'),
          amount: data.amount < 0 ? data.amount * -1 : data.amount
        };

        // if only refund is available select it
        if (!data._links.edit && !data._links.cancel && data._links.refund) {
          this.action = 'refund';
        } else if (!data._links.edit) {
          this.action = 'refund';
        }
      });

    this.invoiceService.get(this.invoiceNumber)
      .then((resp) => {
        this.invoice = resp.data;

        // international
        if (resp.data.international) {
          angular.extend(this.payment, {
            currencyAmount: parseFloat(this.$filter('round')(resp.data.currentBalance / resp.data.international.exchangeRate), 10)
          });
        }
      });
  }

  loadSalesLedger() {
    this.salesLedgerService.getInvoiceEntries(this.invoiceNumber)
      .then((resp) => {
        this.entries = resp.data;
      })
      .then(() => {
        this.salesLedgerService.getInvoiceBalance(this.invoiceNumber)
          .then((resp) => {
            this.balance = resp.data.balance;
          });
      });
  }

  save() {
    if (this.action === 'cancel') {
      this.salesLedgerService.cancelPayment(this.paymentNumber)
        .then(() => this.$location.path('/regning/' + this.invoiceNumber));
    } else {
      if (this.payment.date !== null && typeof this.payment.date !== 'undefined' && moment(this.payment.date, 'DD.MM.YY').isValid()) {
        if (this.payment.amount > 0) {
          let params = {
            date: moment(this.payment.date, 'DD.MM.YY').format('YYYY-MM-DD'),
            amount: this.payment.amount
          };

          if (this.invoice.international) {
            angular.extend(params, {
              currencyAmount: this.payment.currencyAmount
            });
          }

          if (this.action === 'refund') {
            this.salesLedgerService.refundPayment(this.paymentNumber, params)
              .then(() => this.$location.path(`/regning/${this.invoiceNumber}`));
          } else {
            this.salesLedgerService.editPayment(this.paymentNumber, params)
              .then(() => this.$location.path(`/regning/${this.invoiceNumber}`));
          }
        } else {
          this.Notification.error(this.I18N.payments.error.amount);
        }
      } else {
        this.Notification(this.I18N.payments.error.date);
      }
    }
  }
}

EditPayment.$inject = ['$filter', '$routeParams', '$location', 'commonService', 'invoiceService', 'salesLedgerService', 'I18N', 'Notification'];

const editPayment = {
  controller: EditPayment,
  templateUrl: 'sales-ledger/payment-edit.html'
};

angular
  .module('SendRegning')
  .component('editPayment', editPayment)
  .config(($routeProvider) => {
    $routeProvider
      .when('/regning/:number/betaling/:paymentNumber', {
        title: 'Korriger innbetaling',
        template: '<edit-payment />',
        secure: true
      });
  });
